import {z} from "zod";
import {ClientSchema} from "@/components/_Shared/Form/Schemas/ClientSchema.ts";

export const PointOfContactFormSchema = z.object({
    uuid: z.string().optional(),
    name: z.string().min(1, "Name is required"),
    email: z.string().email("Invalid email address").optional().or(z.literal('')),
    phone_number: z.string().regex(/^[0-9()-]{10}$/, "Phone number must be 10 digits and can only contain numbers, parentheses, and dashes").optional().or(z.literal('')),
})
.merge(ClientSchema)